import {  FC, useState, useEffect, useMemo } from "react"
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { TablesWidget10 } from "../../../smallnation/partials/widgets"
import { ErrorMessage } from "@hookform/error-message";
import {  useLocation, useHistory } from "react-router-dom";

//import { useForm } from "react-hookform";
import { useForm } from "react-hook-form";
import services from "../../modules/services/services";
//import $, { parseJSON } from 'jquery';
import $ from 'jquery';
import { Link } from 'react-router-dom';
//import { useNavigate } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
//import css from "../../../smallnation/assets/custom.css";
import UsNumberValidate from "../../modules/utility/usNumberValidate"
import { Breadcrumb } from "react-bootstrap";

const EditCompanyUser: FC = ({ hrefIn }:any) => {
  const intl = useIntl();
  const [categories, setCategory] = useState([]);
  const [locationCounty, setLocationCounty] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [companyProf, setCompanyProfile] = useState([]);

  const [companyList, setCompanyList] = useState([]);
  const [userInfo, setUserInfo] = useState([]);
  const [companyIdUser, setCompanyIdUser] = useState([]);
  let history = useHistory();
  const red = "red";

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const user_id = queryParams.get('userId');
  var companyId = queryParams.get('companyId');
  var emailVal  = '';
  var companyIdVal = '';

  var tabId = queryParams.get('tab');

  const items = [
    { href: "/companyDetails?companyId="+companyId+"&tab=1", name: "Company Details" },
    { href: "/companyDetails?companyId="+companyId+"&tab="+tabId, name: "Company Users" },
    { name: "Edit Company Users" },
  ];

  const {
    register,
    formState: { errors },
    handleSubmit
  } = useForm({
    criteriaMode: "all", mode: "onBlur"
  });

  function validateCheck() {
    //alert("test");
  }

  const submitValue = () => {
    var validateEditorTxt = 1;
    var email_regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if($('#first_name').val() == ""){
      $("#firstNameValidMsg").show();  
        $(window).scrollTop($('#firstNameValidMsg').position().top);
      validateEditorTxt = 0;     
    }else{
      $("#firstNameValidMsg").hide();  
    }

    if($('#last_name').val() == ""){
      $("#lastNameValidMsg").show();  
        $(window).scrollTop($('#lastNameValidMsg').position().top);
      validateEditorTxt = 0;     
    }else{
      $("#lastNameValidMsg").hide();  
    }

    var email_id:any = $('#email_id_sp').val();
  if(email_id == ""){
    $("#emailReqMsg").show();  
      $(window).scrollTop($('#emailReqMsg').position().top);
    validateEditorTxt = 0;     
  }else{
    $("#emailReqMsg").hide();  
  }

  if(email_id != "" && email_regex.test(email_id)==false){
    $("#emailValidMsg").show();  
      $(window).scrollTop($('#emailValidMsg').position().top);
    validateEditorTxt = 0;     
  }else{
    $("#emailValidMsg").hide();  
  }

  if($('#userRole').val() == ""){
    $("#rolevalidmsg").show();  
      $(window).scrollTop($('#rolevalidmsg').position().top);
    validateEditorTxt = 0;     
  }else{
    $("#rolevalidmsg").hide();  
  }  

 
    if(validateEditorTxt == 0){
      return false;
     }
   

    const siteId = "2";
    var accessTokenTov = sessionStorage.getItem("adminAccToken");
    var active_state = $("input[name='activeState']:checked").val();
    //alert(active_state);
   
    if(active_state == "active"){
      active_state = "1";
    }else{
      active_state = "0";
    }
    const requestObject =
    {

      "siteId": "2",
      "firstName": $("#first_name").val(),
      "lastName": $("#last_name").val(),
      "userId": user_id,
      //"email":$("#email_id").val(),
      "companyId": companyIdUser,
      //"password": $("#password").val(),
      "roleName" : $("#userRole").val(),
      "status":active_state
    }
    console.log(JSON.stringify(requestObject));

    var accessTokenIn = sessionStorage.getItem("adminAccToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': "Bearer "+accessTokenIn 
        //'Authorization': accessTokenIn 
      },
      body: JSON.stringify(requestObject)
    };

    services.adminEditCompanyUser(requestOptions).then((res) => {
      if(res.success == "false"){
        var msg = res.message;
        $("#msg_result").html(msg);
      }else{
        if (res.code == '200') {
          $("#editcompanyusersuccessMessage").fadeTo(2000, 500).slideUp(500, function () {
            $("#editcompanyusersuccessMessage").slideUp(500);
          });
          setTimeout(() => {
            if(tabId == null){
              history.push('/editcompany?companyId='+companyId);
            } else{
              history.push('/companyDetails?companyId=' + companyId+'&tab='+tabId);
            }
            
          }, 1000);
        }
        else{
          $("#editcompanyuserfailMessage").fadeTo(2000, 500).slideUp(500, function () {
            $("#editcompanyuserfailMessage").slideUp(500);
          });
          setTimeout(() => {
          }, 1000);
        }
       
      }
      

    });




    // return false; 
  }

  function getUserPRofile(uid){
    //adminGetUserInfo?userId=554
    services.adminGetUserInfo(uid).then((res:any) => {
      console.log(JSON.stringify(res));
      if(res){
        setUserInfo(res);
        $("#first_name").val(res.data.firstName);
        $("#last_name").val(res.data.lastName);
        $("#email_id_sp").val(res.data.email)
        emailVal = res.data.email;
        companyId = res.data.companyId;
        companyIdVal = res.data.companyId;
        setCompanyIdUser(res.data.companyId);
        var role_name = res.data.roleName;
        var db_status = res.data.status;
        if(db_status == "pending"){
          db_status = "active";
        }
        $("input[name=activeState][value=" + db_status + "]").attr('checked', 'checked');
        if(role_name == "employerAdmin"){
          $("#userRole").val("companyadmin");
        }else if(role_name == "employerUser"){
          $("#userRole").val("companyuser");
        }
      }
     

    });

  }

  useEffect(() => {

    //validateCheck();
    //$("#companyProfileValidMsg").hide();
   // $('#phone_number').usPhoneFormat();
   ($('#phone_number') as any).usPhoneFormat();
    //getAdminProfilesList();
    $('#firstNameValidMsg').hide();
$('#lastNameValidMsg').hide();
$("#emailReqMsg").hide();
  $("#emailValidMsg").hide();
  $('#rolevalidmsg').hide();
  
  $('#editcompanyusersuccessMessage').hide();
  $('#editcompanyuserfailMessage').hide();
    getUserPRofile(user_id);

  
  
  }, []);
  return (
    <>

<Breadcrumb style={{opacity:"0.8", paddingBottom:"15px", marginTop:"-15px", borderBottom:"1px solid #999 "}}>
      {items.map((item) =>
        item.href === hrefIn ? (
          <Breadcrumb.Item active>{item.name}</Breadcrumb.Item>
        ) : (
          <Breadcrumb.Item linkProps={{ to: item.href }} linkAs={Link}>
            {item.name}
          </Breadcrumb.Item>
        )
      )}
    </Breadcrumb>

      <PageTitle breadcrumbs={[]}>Edit Company user</PageTitle>
      <form onSubmit={handleSubmit(submitValue)}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="mb-10">
              </div></div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" required form-label">First Name</label>

                </div>
                <input type="text" id="first_name" name="first_name" className="form-control" placeholder=""  />

                <div id="firstNameValidMsg" style={{color:red}} className="error">First Name is required.</div>
              </div>
            </div>


            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" required form-label">Last Name</label>

                </div>
                <input type="text" id="last_name" name="last_name" className="form-control" placeholder="" />

                <div id="lastNameValidMsg" style={{color:red}} className="error">Last Name is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Email</label>
                </div>
                
                <input disabled type="text" id="email_id_sp" name="email_id_sp" className="form-control" placeholder="" />
                
                <div id="emailReqMsg" style={{color:red}} className="error">Email Address is required.</div>

<div id="emailValidMsg" style={{color:red}} className="error">Invalid email address.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Role</label>

                </div>
                <select className="form-select" id="userRole" name="userRole" aria-label="Select example" >
                  <option selected value="companyuser" >Employer User</option>
                  <option selected value="companyadmin" >Employer Admin</option>
                  
                </select>
                <div id="rolevalidmsg" style={{color:red}} className="error">Role is required.</div>
              </div>
            </div>


             <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Status</label>

                </div>
               
                <div className="mb-10">
                  <div className="form-check form-check-custom form-check-solid form-check-sm">
                      <input name="activeState" className="form-check-input" type="radio" value="active" id="flexRadioSm"  />
                      <label className="form-check-label" htmlFor="flexRadioSm">
                          Active
                      </label>
                  </div>
                 
                  <div className="form-check form-check-custom form-check-solid form-check-sm">
                      <input name="activeState" className="form-check-input" type="radio" value="inactive" id="flexRadioSm2"  />
                      <label className="form-check-label" htmlFor="flexRadioSm2">
                          Inactive
                      </label>
                  </div>
                </div>
               
              </div>
            </div> 


            {/* <div className="form-check form-switch form-check-custom form-check-solid me-10">
              <input className="form-check-input h-25px w-40px" type="checkbox" value="" id="flexSwitch25x40"/>
              <label className="form-label" htmlFor="flexSwitch25x40">
                Active
              </label>
            </div>
            */}


            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  
                  <div className="row mt-8">

                


                    {errors.category && errors.category.type === "required" && <div style={{ color: red }} className="error">Please check atleast One category</div>}
                   
                    <div className="divider"></div>

                    <button type="submit" className="btn btn-primary mt-10" style={{ maxWidth: "200px" }}> Update User </button>
                    <div>
                      <span id="msg_result"></span>
                    </div>

                    <div id="editcompanyusersuccessMessage" className="alert alert-success" role="alert">Company User Updated Successfully</div>
                    <div id="editcompanyuserfailMessage" className="alert alert-danger" role="alert">Please try again</div>
                    
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </form>
    </>
  )
}
export { EditCompanyUser }